var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63602",
    "data-name": "Group 63602",
    transform: "translate(-1527.5 -374.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24443",
    "data-name": "Rectangle 24443",
    width: 66,
    height: 66,
    rx: 10,
    transform: "translate(1527.5 374.648)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63699",
    "data-name": "Group 63699",
    transform: "translate(1443.734 383.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63696",
    "data-name": "Group 63696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75483",
    "data-name": "Path 75483",
    d: "M102,28.8a12.948,12.948,0,1,1,14.885,10.97,13.823,13.823,0,0,1-4.186.01c-.484-.07-.558-.263-.586-.685a10.292,10.292,0,0,0-6.965-9.532A22.721,22.721,0,0,0,102,28.8m16.215,2.325h-6.818v3.708h6.818Zm-3.359-6.492a5.865,5.865,0,0,0-.927.213,2.309,2.309,0,0,0,1.6,4.329,2.338,2.338,0,0,0,1.517-2.828.826.826,0,0,1,.17-.653c.77-.817,1.578-1.6,2.368-2.394.448-.452.5-.922.15-1.255s-.781-.288-1.256.18c-.542.535-1.079,1.075-1.618,1.613-.566.566-1.032,1.372-2,.8m9.786,3.112c.38,0,.76.014,1.138,0a.721.721,0,0,0,.755-.7.684.684,0,0,0-.63-.809,17.242,17.242,0,0,0-2.448,0,.692.692,0,0,0-.644.8.732.732,0,0,0,.751.71c.358.017.719,0,1.078,0M114.026,17.074h0c0,.381-.023.764.006,1.142a.768.768,0,0,0,1.536-.017c.026-.721.017-1.443,0-2.164a.733.733,0,0,0-.751-.781.746.746,0,0,0-.794.8c-.014.341,0,.682,0,1.022M104.981,27.75c.34,0,.679.008,1.018,0a.737.737,0,0,0,.795-.726.715.715,0,0,0-.71-.808,16.776,16.776,0,0,0-2.33.007.708.708,0,0,0-.677.834.728.728,0,0,0,.767.69c.378.016.758,0,1.137,0m2.356-4.307c.192-.2.536-.388.575-.63a1.042,1.042,0,0,0-.323-.851,15.664,15.664,0,0,0-1.8-1.076.777.777,0,0,0-1.147.231c-.244.4-.126.8.367,1.1.579.354,1.17.688,1.763,1.02a4.191,4.191,0,0,0,.562.2m14.889-.049a1.446,1.446,0,0,0,.337-.043c.762-.434,1.542-.841,2.27-1.326a.637.637,0,0,0,.09-.963.705.705,0,0,0-.954-.25A17.331,17.331,0,0,0,121.96,22a.945.945,0,0,0-.258.817c.059.249.383.436.524.58M110.242,20.14c.8,0,1.123-.593.8-1.209-.3-.585-.653-1.146-.978-1.72a.8.8,0,0,0-1.117-.387c-.4.174-.5.666-.239,1.146.315.58.63,1.162.993,1.711a2.153,2.153,0,0,0,.539.459m10.879-2.776c-.174-.182-.333-.464-.57-.569a.7.7,0,0,0-.933.315c-.358.6-.721,1.2-1.054,1.813a.779.779,0,1,0,1.348.767c.346-.585.68-1.177,1.008-1.772a4.205,4.205,0,0,0,.2-.554",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75484",
    "data-name": "Path 75484",
    d: "M100.384,28.872l-3.756,1.173a18.458,18.458,0,1,1,14.106,14.91l1.375-3.673a14.529,14.529,0,1,0,4.263-28.722,14.025,14.025,0,0,0-11.95,4.306,14.274,14.274,0,0,0-4.038,12.006",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75485",
    "data-name": "Path 75485",
    d: "M110.578,39.461a8.992,8.992,0,1,1-9.04-8.972,8.947,8.947,0,0,1,9.04,8.972m-7.141-5.492-.11-.059-5.1,6.5H101c-.443,1.569-.864,3.064-1.286,4.558l.112.049,5.142-6.448h-2.742c.419-1.592.814-3.1,1.21-4.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75486",
    "data-name": "Path 75486",
    d: "M132.358,0a11.6,11.6,0,0,1,8.155,3.23,1.344,1.344,0,0,1,.425.8.767.767,0,0,1-.451.606,1.2,1.2,0,0,1-.9-.226,10.378,10.378,0,0,0-3.593-2.236A10.068,10.068,0,0,0,125.666,4.1c-.123.1-.236.217-.352.327a.777.777,0,0,1-1.171.085c-.356-.32-.307-.79.127-1.2A11.63,11.63,0,0,1,132.358,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75487",
    "data-name": "Path 75487",
    d: "M132.634,3.026A8.622,8.622,0,0,1,138.42,5.4c.314.29.533.609.314,1.053-.26.527-.777.583-1.288.116a7.232,7.232,0,0,0-9.683-.282c-.169.141-.323.3-.5.434a.688.688,0,0,1-1.015-.108.676.676,0,0,1-.007-.978,7.117,7.117,0,0,1,.938-.839,8.738,8.738,0,0,1,5.453-1.767",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75488",
    "data-name": "Path 75488",
    d: "M132.879,6.057a5.533,5.533,0,0,1,3.373,1.464c.453.405.536.921.224,1.259-.327.355-.729.325-1.214-.089a4.126,4.126,0,0,0-5.673.019c-.48.406-.9.43-1.2.035a.784.784,0,0,1,.167-1.161,6.063,6.063,0,0,1,4.324-1.527",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75489",
    "data-name": "Path 75489",
    d: "M132.46,13.629a1.89,1.89,0,1,1,1.879-1.88,1.939,1.939,0,0,1-1.879,1.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75490",
    "data-name": "Path 75490",
    d: "M115.567,26.993c-.059.435-.279.736-.76.736a.692.692,0,0,1-.754-.743.7.7,0,0,1,.745-.76.746.746,0,0,1,.769.767",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon1);
export default __webpack_public_path__ + "static/media/services-icon-1.2b8ac301812e69e89a495e6169dfcebe.svg";
export { ForwardRef as ReactComponent };